export const frag = /*glsl*/ `
precision mediump float;

uniform vec3 uColor;
uniform float uTime;
uniform sampler2D tNoise;

varying vec2 vUv;

#define PI 3.141592

void main(){
	vec2 cUv = vUv - 0.5;
	vec2 sUv = vec2(length(cUv), fract(atan(cUv.x, cUv.y) / (PI * 2.) - uTime * .0005 + length(cUv) * texture2D(tNoise, vec2(length(cUv) + uTime * 0.00001)) * 3.));

	vec3 color = smoothstep(.2, .25, sUv.x) * smoothstep(.3, .25, sUv.x) * smoothstep(-.5, .7, sUv.y) * smoothstep(1., .7, sUv.y) * uColor * texture2D(tNoise, vec2(sUv.x * .5)).r * 2.;
	color += smoothstep(.0, .25, sUv.x) * smoothstep(.5, .25, sUv.x) * smoothstep(.0, .9, sUv.y) * smoothstep(1., .9, sUv.y) * uColor * .3;

	gl_FragColor = vec4(color * 10., 1.);
}`;
